/**
 * LangBadge — petite etiquette FR/EN, monochrome.
 *
 *   <LangBadge lang="fr" /> <LangBadge lang="en" />
 *
 * Utilise sur les contenus bilingues quand le contexte est ambigu (ex:
 * crayon de surcharge `<EditableTranslation>`, panel "Versions linguistiques").
 */

import Badge from './Badge'

interface LangBadgeProps {
  lang: 'fr' | 'en'
  size?: 'sm' | 'md'
}

export default function LangBadge({ lang, size = 'sm' }: LangBadgeProps) {
  return (
    <Badge variant="solid" size={size} title={lang === 'fr' ? 'Français' : 'English'}>
      {lang.toUpperCase()}
    </Badge>
  )
}
